<template>
  <div class="new-homework">
    <div class="header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'homeworkList' }">{{$t("homeworkManage.jobManagement")}}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{$t("homeworkManage.newHomework")}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="new-homework-content">
      <el-form size="small" label-width="150px" ref="ruleForm" :model="ruleForm" :rules="rules">
        <el-form-item :label="$t('homeworkManage.newContent')" prop="fileList"
                      class="upload-form-item">
          <div class="upload-demo">
            <el-upload :file-list="ruleForm.fileList" action :limit="1" :on-change="uploadChange"
                       :before-upload="beforeUploadFile" :http-request="uploadSectionFile"
                       :show-file-list="false" :accept="acceptStr" :on-exceed="handleExceed">
              <el-button>{{$t('common.uploadFile')}}</el-button>
            </el-upload>
            <div v-if="ruleForm.fileList.length > 0" class="file-list">
              <span class="file-name">{{ruleForm.fileList[0].name}}</span>
              <i class="icon-empty" @click="handleEmpty"></i>
            </div>
          </div>
          <span
                class="el-upload__tip">{{$t('newProjectV2.suppFormat')}}：{{$supportFileSuffixes().tip}}，{{$t('homeworkManage.fileSizeExceed',[20])}}</span>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('jobManagementV2.jobName')" prop="name">
              <el-input v-model.trim="ruleForm.name"
                        :placeholder="$t('jobManagementV2.jobInputText')" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('newProjectV2.sourceLang')" prop="sourceLang">
              <el-select @change="sourceLangChanges" v-model="ruleForm.sourceLang"
                         :placeholder="$t('newProjectV2.sourceLangTip')">
                <el-option v-for="(item, index) in sourceLangList" :key="index"
                           :label="$i18n.locale === 'zh' ? item.sourceLangName : $langCase[item.sourceLang]"
                           :value="item.sourceLang"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newProjectV2.targetLang')" prop="targetLang">
              <el-select :no-data-text="$t('newProjectV2.firstSelSourceLangTip')"
                         v-model="ruleForm.targetLang"
                         :placeholder="$t('newProjectV2.targetLangTip')">
                <el-option v-for="(item, index) in targetLangList" :key="index"
                           :label="$i18n.locale === 'zh' ? item.targetLangName : $langCase[item.targetLang]"
                           :value="item.targetLang"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('newProjectV2.domain')" prop="domainCode">
              <el-select ref="domainCodeSelect" :no-data-text="$t('newProjectV2.firstSelSourceLangTip')"
                         v-model="ruleForm.domainCode" :placeholder="$t('newProjectV2.domainTip')" 
                         @change="changedomainCode">
                <el-option value="add_domain" v-if="HOMEWORK_HAS_CUSTOM_DOMAIN"><span  style="color: #0078fc;">+{{ $t('project.create') }}</span></el-option>
                <el-option v-for="(item, index) in domainList" :key="index"
                           :label="$i18n.locale === 'zh' ? item.transDomainName : $domainCase[item.transDomainCode]"
                           :value="item.transDomainCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('newProjectV2.limitTime')" prop="deliveryTime">
              <el-date-picker type="datetime" :placeholder="$t('newProjectV2.dateTip')"
                              :editable="false" :clearable="false" v-model="ruleForm.deliveryTime"
                              :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                              format="yyyy-MM-dd HH:mm"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="机器翻译">
              <el-switch v-model="ruleForm.isPreMt"></el-switch>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-form-item :label="$t('newProjectV2.remark')" class="desc-form-item">
          <el-input type="textarea" v-model="ruleForm.remark" resize="none" maxlength="70"></el-input>
        </el-form-item>
        <el-form-item class="btn-form-item">
          <el-button class="cancel" @click="handleCancel">{{$t('newProjectV2.cancel')}}</el-button>
          <el-button type="primary" @click="handleNextStep">{{$t('newProjectV2.nextStep')}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
     <!-- 创建自定义领域 -->
    <create-custom-domain :dialogVisible="createDomainVisible" @handleClose="handleCreateDomainClose"
      @handleConfirm="handleCreateDomainConfirm">
    </create-custom-domain>
  </div>
</template>

<script>
import moment from 'moment';
import CreateCustomDomain from '@/components/create-custom-domain';

import { getFileLang, getUploadSign, queryLangList, queryTransDomain ,queryDefaultTransDomain} from '@/services/newProjectApi';

import { upload } from '@/services/commonApi';

export default {
  name: 'NewHomework',
   components: {
    CreateCustomDomain
  },
  data () {
    // 当前时间的往后七天
    const time = moment().add(7, 'd').format('YYYY-MM-DD HH:mm:ss');

    const checkLimitTime = (rule, value, callback) => {
      if (this.ruleForm.deliveryTime === '') {
        return callback(new Error('请选择截止时间'));
      }
      else if (new Date(new Date(this.ruleForm.deliveryTime).setMinutes(new Date(this.ruleForm.deliveryTime).getMinutes() + 1)) < new Date()) {
        return callback(new Error(this.$t('projectV2.limitTimeErrorText')));
      } else {
        callback();
      }
    }
 const checkDomain = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$t('newProjectV2.domainTip')))
      }
      if (this.$refs.domainCodeSelect.createdSelected && this.HOMEWORK_HAS_CUSTOM_DOMAIN) {
        this.ruleForm.domainCode = this.ruleForm.domainCode.trim();
        if (value.length < 1 || value.length > 10) {
          return callback(new Error(this.$t('common.customDomainLength')));
        }
      }
      callback();
    }
    return {
      HOMEWORK_HAS_CUSTOM_DOMAIN: HOMEWORK_HAS_CUSTOM_DOMAIN,
      sourceLangList: [],
      targetLangList: [],
      domainList: [],
      notGetLong: true,
      notChangeLang: true,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < new Date().getTime() - 86400000;
        },
      },
      acceptStr: this.$supportFileSuffixes().acceptStr,  // 支持文件格式
      ruleForm: {
        fileList: [],
        name: '',
        sourceLang: '',
        targetLang: '',
        domainCode: '',
        deliveryTime: time,
        // isPreMt: false,
        remark: '',
      },
      rules: {
        fileList: [
          { required: true, message: this.$t('homeworkManage.selectFile'), trigger: 'change' }
        ],
        name: [
          { required: true, message: this.$t('jobManagementV2.enterobName'), trigger: 'blur' },
          { min: 1, max: 50, message: this.$t('newProjectV2.projectNameLength'), trigger: 'blur' },
        ],
        sourceLang: [
          { required: true, message: this.$t('newProjectV2.sourceLangTip'), trigger: 'change' }
        ],
        targetLang: [
          { required: true, message: this.$t('newProjectV2.targetLangTip'), trigger: 'change' }
        ],
        domainCode: [
          // { required: true, message: this.$t('newProjectV2.domainTip'), trigger: 'change' }
           { required: true, validator: checkDomain, trigger: 'change' },
        ],
        deliveryTime: [
          { validator: checkLimitTime, trigger: 'change', required: true }
        ],
      },
      createDomainVisible: false,
      domainCodeCopy: "", //dimaincode拷贝的值
    }
  },
  async mounted () {
    this.sourceLangList = await this.getLangList({ type: 1 });
    this.getQueryDefaultTransDomain()
  },
  methods: {
    handleNextStep () {
      let flag = false;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          flag = valid;
        }
      });
      if (!flag) {
        return;
      }
      // 获取源语言中文名
      let sourceName = this.sourceLangList.find(i => this.ruleForm.sourceLang === i.sourceLang).sourceLangName;
      // 获取目标语言中文名
      let targetName = this.targetLangList.find(i => this.ruleForm.targetLang === i.targetLang).targetLangName;
      // 文件列表
      let fileList = this.ruleForm.fileList.map(item => {
        return {
          name: item.name,
          filePath: item.filePath,
          fileSuffix: /([^\.\/\\]+)\.([a-z]+)$/i.exec(item.name)[2]
        }
      });

      // 获取领域中文名
      let domainName = this.domainList.find(i => this.ruleForm.domainCode === i.transDomainCode).transDomainName.transDomainName;

      this.$router.push({
        name: 'homeworkSetting',
        query: {
          key: this.$Base64.encode(JSON.stringify({
            ...this.ruleForm,
            langDesc: sourceName + '>' + targetName,
            fileList,
            domainName,
          }))
        },
      });
    },
    async uploadSectionFile (param) {
      // 获得上传签名
      let { success, result } = await getUploadSign();
      if (!success) {
        return;
      }
      let type = param.file.name.substring(param.file.name.lastIndexOf(".") + 1).toLocaleLowerCase();
      let para = {
        ...result,
        key: `${result.keyPrefix}.${type}`,
        file: param.file,
      };
      Reflect.deleteProperty(para, 'keyPrefix');
      Reflect.deleteProperty(para, 'host');

      let formData = new FormData();
      Object.keys(para).forEach(function (key) {
        formData.append(key, para[key]);
      });
      this.uploadFile(formData, result.host, param);
    },
    async uploadFile (formData, host, param) {
      let { success, result } = await upload(host, formData, {
        onUploadProgress: progressEvent => {
          const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      });
      if (success) {
        this.ruleForm.fileList.forEach((item, index) => {
          if (item.uid == param.file.uid) {
            this.$set(this.ruleForm.fileList[index], 'filePath', result.fileName);
          }
        });

        this.$refs.ruleForm.validateField('fileList');
        // 项目名称默认获得第一个文件的名称
        this.ruleForm.name = this.ruleForm.fileList[0].name.substring(0, this.ruleForm.fileList[0].name.lastIndexOf(".")).substring(0, 50);
        if (this.notChangeLang) {
          this.getLong(result.fileName, param);
        }
      } else {
        this.ruleForm.fileList = [];
      }
    },
    // 获取文件语言
    async getLong (fileName) {
      let { success, result } = await getFileLang({
        path: fileName
      });
      if (success) {
        // 如果文件源语言检测为空，则跳过
        if (!result.sourceLang) {
          return;
        }
        this.ruleForm.sourceLang = result.sourceLang;
        this.sourceLangChange();
      }
    },
    async getQueryDefaultTransDomain() {
      const { success, result } = await queryDefaultTransDomain({})
      if (success) {
        this.domainList = result
      }
    },
    async getDomainList (sourceLangCode, targetLangCode) {
      let { result, success } = await queryTransDomain({
        sourceLangCode,
        targetLangCode
      })
      if (!success) { return; }
      this.domainList = result;
      // 领域默认选择第一项
      if ((!this.ruleForm.domainCode) || !(this.domainList.map(item => item.transDomainCode).includes(this.ruleForm.domainCode))) {
        this.ruleForm.domainCode = result[0].transDomainCode;
        this.domainCodeCopy = result[0].transDomainCode;
      }
    },
     //领域change事件
    changedomainCode(value) {
      if (value === 'add_domain') {
        this.createDomainVisible = true
        this.ruleForm.domainCode = this.domainCodeCopy
        return
      }
      this.domainCodeCopy = value;
    },
    handleCreateDomainClose() {
      this.createDomainVisible = false
      this.ruleForm.domainCode = this.ruleForm.domainCode === 'add_domain' ? '' : this.ruleForm.domainCode
    },
    
    async handleCreateDomainConfirm(data) {
      if (this.ruleForm.sourceLang) {
        await this.getDomainList(this.ruleForm.sourceLang, this.ruleForm.targetLang)
      } else {
        await this.getQueryDefaultTransDomain()
      }
      if (!this.ruleForm.domainCode) {
        this.domainList.forEach(item => {
          if (item.transDomainName === data.domain) {
            this.ruleForm.domainCode = item.transDomainCode
          }
        })
      }
      this.createDomainVisible = false
    },
    sourceLangChanges () {
      this.notChangeLang = false;
      this.sourceLangChange();
    },
    async sourceLangChange () {
      let targetLangList = await this.getLangList({
        type: 2,
        sourceLang: this.ruleForm.sourceLang,
      });
      this.targetLangList = targetLangList.filter(item => item.status === 1);
      this.ruleForm.targetLang = this.targetLangList[0].targetLang;
      this.getDomainList(this.ruleForm.sourceLang, this.ruleForm.targetLang);
    },
    handleExceed () {
      this.$message.closeAll();
      this.$message.warning(this.$t('newProjectV2.singleFileSize', [20, 1]));
    },
    uploadChange (file, fileList) {
      this.ruleForm.fileList = fileList;
    },
    beforeUploadFile (file) {
      // 文件格式
      let format = file.name.substring(file.name.lastIndexOf(".") + 1).toLocaleLowerCase();
      let typeFlag = this.$supportFileSuffixes(format).isSupport;
      let isFileNameLength = file.name.length > 160
      if (!typeFlag) {
        this.$message.warning(this.$t('newProjectV2.onlySupportFormate', [this.$fileSuffix.tips]));
        return false;
      }
      if (isFileNameLength) {
        this.$message.warning(this.$t('newProjectV2.fileNameLength'))
        return false;
      }
      if (file.size / 1024 / 1024 > 20) {
        this.$message.warning(this.$t('newProjectV2.maxUploadFileSize', [20]));
        return false;
      }
    },
    // 获取语言列表
    async getLangList (param) {
      let { success, result } = await queryLangList({
        ...param
      });
      if (success) {
        return result;
      }
      return [];
    },
    handleCancel () {
      this.$router.push({ name: 'homeworkList' });
    },
    handleEmpty () {
      this.ruleForm.fileList = [];
    },
  },
}
</script>

<style lang="less" scoped>
.new-homework {
  background: #fff;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  line-height: 1.5;
  text-align: left;
  min-height: 645px;
}
.new-homework-content {
  width: 780px;
  margin-top: 40px;
  /deep/ .el-form-item {
    height: 32px;
  }
  .upload-demo {
    display: flex;
  }
  .file-list {
    margin-left: 20px;
    display: flex;
    align-items: center;
    .file-name {
      height: 32px;
      max-width: 500px;
      overflow: hidden;
    }
    .icon-empty {
      display: inline-block;
      width: 16px;
      height: 16px;
      cursor: pointer;
      margin-left: 10px;
      background: url("~@/assets/imgs/homework/icon-del.png") no-repeat center
        center/16px 16px;
      &:hover {
        background: url("~@/assets/imgs/homework/icon-del-pre.png") no-repeat
          center center/16px 16px;
      }
    }
  }
  .el-upload__tip {
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;
    margin-top: 0;
    line-height: 12px;
  }
  .desc-form-item,
  .upload-form-item {
    height: auto;
  }
  /deep/ .el-select {
    width: 100%;
    .el-input--small .el-input__icon {
      line-height: 30px;
    }
  }
  /deep/.el-date-editor {
    width: 100%;
  }
  /deep/.el-textarea {
    height: 222px;
    .el-textarea__inner {
      height: 100%;
    }
  }
  .btn-form-item {
    text-align: center;
    /deep/.el-button {
      min-width: 70px;
      padding: 0 5px;
      height: 32px;
      font-size: 14px;
    }
    /deep/.el-button + .el-button {
      margin-left: 20px;
    }
    .cancel {
      border: 1px solid #0078fc;
      color: #0078fc;
    }
  }
}
</style>